import { Label } from '@rossum/api-client/labels';
import { Chip, Stack, Tooltip, Typography } from '@rossum/ui/material';
import { LabelChip } from '../../../ui/labels/LabelChip';

type LabelsColumnProps = {
  labels: Array<Label>;
  maxVisibleLabelCount?: number;
  restrictedAccess?: boolean;
};

const NUMBER_OF_VISIBLE_LABELS = 3;

const LabelsColumn = ({
  labels,
  maxVisibleLabelCount,
  restrictedAccess,
}: LabelsColumnProps) => {
  const numberOfVisibleLabels =
    maxVisibleLabelCount ?? NUMBER_OF_VISIBLE_LABELS;

  const head = labels.slice(0, numberOfVisibleLabels);
  const tail = labels.slice(numberOfVisibleLabels);

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      {head.map(({ name, color, url }) => (
        <LabelChip
          name={name}
          color={color}
          key={url}
          disabled={!!restrictedAccess}
        />
      ))}
      {tail.length > 0 && (
        <Tooltip
          placement="top"
          title={tail.map(({ name, url }) => (
            <Typography variant="body2" key={url}>
              {name}
            </Typography>
          ))}
          enterDelay={600}
        >
          <Chip label={`+${tail.length}`} />
        </Tooltip>
      )}
    </Stack>
  );
};

export { LabelsColumn };
